import { useState, useEffect } from "react";
import { useNotifications } from "../context/NotificationsContext";
import { mdiBell } from "@mdi/js";
import Icon from "@mdi/react";
import { useNavigate } from "react-router-dom";
import { userService } from "../services/UserService";

export function NotificationButton() {
  const { notifications, setNotifications } = useNotifications();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const userNotifications = await userService.getNotifications();
        setNotifications(userNotifications);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    fetchNotifications();
  }, [setNotifications]);

  const handleNotificationClick = (notification) => {
    console.log("notification", notification);
    if (notification.data?.reservationId) {
      navigate(`/confirm-reservation?reservation=${notification.data.reservationId}`);
    } else if (notification.schoolId && notification.startHour) {
      navigate(`/confirm-reservation?date=${notification.startHour}&schoolId=${notification.schoolId}`);
    }
    setShowModal(false);
  };

  return (
    <>
      <button
        className="btn btn-primary position-fixed rounded-circle d-flex align-items-center justify-content-center"
        style={{
          bottom: "20px",
          right: "20px",
          width: "50px",
          height: "50px",
          zIndex: 1000,
          padding: 0,
        }}
        onClick={() => setShowModal(true)}
      >
        <Icon path={mdiBell} size={1.2} color="white" />
        {notifications.length > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: "0.7rem" }}
          >
            {notifications.length}
          </span>
        )}
      </button>

      {showModal && (
        <div
          className="modal show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Notificações</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {notifications.length === 0 ? (
                  <p className="text-center">Nenhuma notificação</p>
                ) : (
                  <div className="d-flex flex-column gap-2">
                    {[...notifications]
                      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                      .map((notification, index) => (
                      <div
                        key={index}
                        className="card"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleNotificationClick(notification)}
                      >
                        <div className="card-body">
                          <p className="card-text">{notification.message}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
